export default {
  links: {
    forum: process.env.NODE_ENV === 'development' ? 'http://forum.pokemondata.local/' : 'http://forum.pokemondata.com/',
  },
  API: {
    host: process.env.NODE_ENV === 'development' ? 'http://localhost:4195/' : 'http://api.pokemondata.com/',
  },
  paths: {
    pokemon: {
      thumbs: '/artwork/pokemon/thumbs/',
      sprites: '/sprites/pokemon/',
    },
  },
  data: {
    pokemon: {
      genders: {
        1: 'female',
        2: 'male',
        3: 'genderless',
      },
      stats: {
        hp: 'HP',
        attack: 'Attack',
        defense: 'Defense',
        'special-attack': 'Sp. Att',
        'special-defense': 'Sp. Def',
        speed: 'Speed',
      },
    },
    games: {
      names: {
        'red-blue': 'Red/Blue',
        yellow: 'Yellow',
        'gold-silver': 'Gold/Silver',
        crystal: 'Crystal',
        'ruby-sapphire': 'Ruby/Sapphire',
        emerald: 'Emerald',
        colosseum: 'Colosseum',
        xd: 'XD',
        'firered-leafgreen': 'Firered/Leafgreen',
        'diamond-pearl': 'Diamond/Pearl',
        platinum: 'Platinum',
        'heartgold-soulsilver': 'Heartgold/Soulsilver',
        'black-white': 'Black/White',
        'black-2-white-2': 'Black 2/White 2',
        'x-y': 'X/Y',
        'omega-ruby-alpha-sapphire': 'Omega Ruby/Alpha Sapphire',
        'sun-moon': 'Sun/Moon',
        'ultra-sun-ultra-moon': 'Ultra Sun/Ultra Moon',
      },
      shortNames: {
        'red-blue': 'R/B',
        yellow: 'Y',
        'gold-silver': 'G/S',
        crystal: 'C',
        'ruby-sapphire': 'R/S',
        emerald: 'E',
        colosseum: 'C',
        xd: 'XD',
        'firered-leafgreen': 'F/L',
        'diamond-pearl': 'D/P',
        platinum: 'P',
        'heartgold-soulsilver': 'H/S',
        'black-white': 'B/W',
        'black-2-white-2': 'B2/W2',
        'x-y': 'X/Y',
        'omega-ruby-alpha-sapphire': 'OR/AS',
        'sun-moon': 'S/M',
        'ultra-sun-ultra-moon': 'US/UM',
      },
    },
  },
}
